import { getCookie } from 'stash/utils/cookies';

export const ATTRIBUTION_PROPERTIES = 'attribution_properties';

export const getStoredInstrumentationAttributions = () => {
	try {
		return JSON.parse(sessionStorage.getItem(ATTRIBUTION_PROPERTIES) || '{}');
	} catch (e) {
		console.error('Failed to parse attribution properties:', e);
		return {};
	}
};

export const setStoredInstrumentationAttributions = (properties) => {
	try {
		sessionStorage.setItem(ATTRIBUTION_PROPERTIES, JSON.stringify(properties));
	} catch (e) {
		console.error('Failed to store attribution properties:', e);
	}
};

export const defaultAttributionData = ({ utm_provider }) => {
	return {
		providers: [
			{
				provider: utm_provider,
				type: 'UNHANDLED_UTM_PROVIDER',
			},
		],
	};
};

export const ImpactRadius = ({ utm_provider, utm_source }) => {
	return {
		providers: [
			{
				provider: utm_provider,
				provider_data: {
					clickId: getCookie('clickid'),
					utm_source,
				},
			},
		],
	};
};

export const Facebook = ({ utm_provider }) => {
	return {
		providers: [
			{
				provider: utm_provider,
				provider_data: {
					fbp: getCookie('_fbp'),
					fbc: getCookie('_fbc'),
					fbclid: getCookie('fbclid'),
				},
			},
		],
	};
};

export const providers = {
	ImpactRadius,
	Facebook,
};

export const getBookieAttributionData = (utm_values) => {
	const { utm_provider } = utm_values;
	const providerHandler = providers[utm_provider];

	if (utm_provider && !providerHandler) {
		const providerData = defaultAttributionData(utm_values);

		return {
			attribution_data: providerData,
		};
	}

	const providerData =
		typeof providerHandler === 'function' && providerHandler(utm_values);

	return providerData
		? {
				attribution_data: providerData,
		  }
		: {};
};

export const getInstrumentationProperties = () => {
	const fbclid = getCookie('fbclid');
	const gclid = getCookie('gclid');
	const irclickid = getCookie('irclickid');
	const ttclid = getCookie('ttclid');
	const utm_medium = getCookie('utm_medium');
	const utm_source = getCookie('utm_source');
	const utm_campaign = getCookie('utm_campaign');

	return {
		...(fbclid && { fbclid: `fb.1.${Date.now()}.${fbclid}` }),
		...(gclid && { gclid }),
		...(ttclid && { ttclid }),
		...(irclickid && { irclickid }),
		...(utm_medium && { utm_medium }),
		...(utm_source && { utm_source }),
		...(utm_campaign && { utm_campaign }),
		frontend_platform: 'web',
	};
};
